import { useRef } from 'react';
export const useAddOnLogError = (result, onLogError) => {
    const prevError = useRef(result.error);
    if (result.error && prevError.current !== result.error) {
        prevError.current = result.error;
        onLogError(result.error);
    }
    return result;
};
